








































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';
import { setFocusOnFirstInput } from '@/utils/setFocusOnFirstInput';
import OutlinedButton from '@/components/molecules/OutlinedButton/OutlinedButton.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Input from '@/componentsV2/molecules/Inputs/TextField.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    OutlinedButton,
    FilledButton,
    Input,
    ValidationObserver,
    ValidationProvider,
    Typography
  }
})
export default class ApiTokenConnectProviderTooltip extends Vue {
  @Prop({ default: false }) visible!: boolean;
  @Prop({ default: 'clover' }) providerName!: string;

  formData = {
    apiToken: '',
    account: ''
  };

  url = '';

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  get tPrefix() {
    return 'common.components.businessProvider';
  }

  cancel() {
    this.$ga.event({
      eventCategory: 'integrations',
      eventAction: 'click-cancel',
      eventLabel: 'Complete the connection'
    });

    this.clearFields();

    this.$emit('cancel');
  }

  clearFields() {
    const accountInput = document.querySelector<HTMLInputElement>(
      '[name="account"]'
    )!;
    const apiTokenInput = document.querySelector<HTMLInputElement>(
      '[name="apiToken"]'
    )!;

    this.formData = {
      account: '',
      apiToken: ''
    };

    accountInput.value = '';
    apiTokenInput.value = '';
  }

  async confirm() {
    const isFormValid = await this.validateForm();

    if (!isFormValid) {
      setFocusOnFirstInput('input[aria-invalid="true"]');
      return;
    }

    this.$ga.event({
      eventCategory: 'integrations',
      eventAction: 'click-confirm',
      eventLabel: String(
        this.$t(`${this.tPrefix}.providerApiTokenModalTitle`, {
          provider: this.providerName
        })
      )
    });

    const payload = {
      apiToken: this.formData.apiToken,
      account: this.formData.account
    };

    this.$emit('confirm', payload);
  }

  async validateForm() {
    const formRef = this.$refs.observer;
    return formRef.validate();
  }

  trackHelpLink() {
    segmentIo.track('Clicked Integration Help Link', {
      Provider: this.providerName,
      Link: 'Clover Setup Guide',
      Origin: 'Connect Tooltip'
    });
  }
}
